module.exports = __webpack_public_path__ + "static/media/one.7dae3a08.jpg";